import { createMemoStyles } from '@wds/styles';
import { PricingAppTheme } from '~app/styles/pricing/types';

export default createMemoStyles(({ spacing, palette }: PricingAppTheme) => ({
  SelectUser: {
    margin: [0, 0, spacing[5]],
    textAlign: 'left',
    display: 'flex',
    flexWrap: 'wrap',
    columnGap: spacing[3],
    alignItems: 'center',
    minHeight: 40,

    '& > svg': {
      margin: 0,
    },

    '& > div': {
      maxWidth: 90,
      flexGrow: 0,
    },

    '& ul li div': {
      flexDirection: 'row-reverse',
      paddingLeft: spacing[4],

      '&[disabled]': {
        opacity: 1,
        borderBottom: `1px solid ${palette.border.muted}`,
      },
    },
  },
}));
